import { render, staticRenderFns } from "./DepositButtons.vue?vue&type=template&id=af376b9c&"
import script from "./DepositButtons.vue?vue&type=script&lang=js&"
export * from "./DepositButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports